import CancellableHelper from "@/requests/CancellableHelper";
import { EditPayment, DataAfterAddPayment } from "@/models/api/payments/EditPayment";
import { PAYMENT_VM_STATE } from "@/static/paymentVmState";
import { CalculatePaymentSummaryRequest } from "@/models/api/payments/CalculatePaymentSummaryRequest";
import { CalculatePaymentSummaryResponse } from "@/models/api/payments/CalculatePaymentSummaryResponse";
import { RecalculateValueInDocumentCurrencyAfterPaymentAmountInCurrencyChangeRequest } from "@/models/api/payments/RecalculateValueInDocumentCurrencyAfterPaymentAmountInCurrencyChangeRequest";
import { DoubleConfirm } from "@/models/api/DoubleConfirm";

//#region Routes
const URL_GET_DATA_FOR_NEW_PAYMENT = "/Payment/${CurrentId}/DataForNewPayment/${State}";
const URL_GET_DATA_FOR_EDIT_PAYMENT = "/Payment/${PaymentId}/DataForEditPayment/${OrderId}";
const URL_POST_ADD_NEW_PAYMENT = "/Payment/New";
const URL_POST_EDIT_PAYMENT = "/Payment/${PaymentId}/Edit";
const URL_POST_REMOVE_PAYMENT = "/Payment/${PaymentId}/Remove";
const URL_GET_RECALCULATE_VALUE_IN_DOCUMENT_CURRENCY_AFTER_PAYMENT_AMOUNT_IN_CURRENCY_CHANGE =
  "/Payment/RecalculateValueInDocumentCurrencyAfterPaymentAmountInCurrencyChange";
const URL_GET_CALCULATE_PAYMENT_SUMMARY = "/Payment/CalculatePaymentSummary";
const URL_GET_IS_PAYMENT_PRINTED_ON__DOCUMENT = "/Payment/${PaymentId}/IsPrintedOnDocument";
//#endregion

const _getDataForNewPayment = new CancellableHelper<EditPayment>(URL_GET_DATA_FOR_NEW_PAYMENT, EditPayment);
export const getDataForNewPayment = async (currentId: string, state: PAYMENT_VM_STATE): Promise<EditPayment> => {
  return await _getDataForNewPayment.get({
    CurrentId: currentId,
    State: state,
  });
};

const _getDataForEditPayment = new CancellableHelper<EditPayment>(URL_GET_DATA_FOR_EDIT_PAYMENT, EditPayment);
export const getDataForEditPayment = async (paymentId: number, orderId: string): Promise<EditPayment> => {
  return await _getDataForEditPayment.get({
    PaymentId: paymentId,
    OrderId: orderId,
  });
};

const _postAddNewPayment = new CancellableHelper<DataAfterAddPayment>(URL_POST_ADD_NEW_PAYMENT, DataAfterAddPayment);
export const postAddNewPayment = async (editPayment: EditPayment): Promise<DataAfterAddPayment> => {
  return await _postAddNewPayment.post({}, editPayment);
};

const _checkIsPaymentPrintedOnDocument = new CancellableHelper<boolean>(URL_GET_IS_PAYMENT_PRINTED_ON__DOCUMENT);
export const checkIsPaymentPrintedOnDocument = async (paymentId: number): Promise<boolean> => {
  return await _checkIsPaymentPrintedOnDocument.get({ PaymentId: paymentId });
};

const _postEditPayment = new CancellableHelper<DataAfterAddPayment>(URL_POST_EDIT_PAYMENT, DataAfterAddPayment);
export const postEditPayment = async (editPayment: EditPayment, paymentId: number): Promise<DataAfterAddPayment> => {
  return await _postEditPayment.post({ PaymentId: paymentId }, editPayment);
};

const _getCalculatePaymentSummary = new CancellableHelper<CalculatePaymentSummaryResponse>(
  URL_GET_CALCULATE_PAYMENT_SUMMARY,
  CalculatePaymentSummaryResponse
);
export const getCalculatePaymentSummary = async (
  param: CalculatePaymentSummaryRequest
): Promise<CalculatePaymentSummaryResponse> => {
  return await _getCalculatePaymentSummary.get(param);
};

const _getRecalculateValueInDocumentCurrencyAfterPaymentAmountInCurrencyChange = new CancellableHelper<number>(
  URL_GET_RECALCULATE_VALUE_IN_DOCUMENT_CURRENCY_AFTER_PAYMENT_AMOUNT_IN_CURRENCY_CHANGE
);
export const getRecalculateValueInDocumentCurrencyAfterPaymentAmountInCurrencyChange = async (
  param: RecalculateValueInDocumentCurrencyAfterPaymentAmountInCurrencyChangeRequest
): Promise<number> => {
  return await _getRecalculateValueInDocumentCurrencyAfterPaymentAmountInCurrencyChange.get(param);
};

const _removePayment = new CancellableHelper<DoubleConfirm>(URL_POST_REMOVE_PAYMENT, null, true);
export const removePayment = async (paymentId: number, confirmed: boolean): Promise<DoubleConfirm> => {
  return await _removePayment.post({ PaymentId: paymentId, Confirmed: confirmed }, null);
};
